export const ticketScroll = () => {
    const ticket = document.querySelector('.ticket');
    const footerTicket = document.getElementById('ticket');

    if (!ticket) return;

    let lastScrollY = window.scrollY;
    let isFooterVisible = false;
    let showTimeout = null;

    // Observer to detect when we reach the ticket section (footer)
    if (footerTicket) {
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                isFooterVisible = entry.isIntersecting;
                checkVisibility();
            });
        });
        observer.observe(footerTicket);
    }

    const checkVisibility = () => {
        // 1. If at footer, always hide
        if (isFooterVisible) {
            ticket.classList.remove('is-visible');
            return;
        } else {
            // If not at footer, show (e.g., initial load)
            ticket.classList.add('is-visible');
        }
    };

    const handleScroll = () => {
        const currentScrollY = window.scrollY;

        // Clear any existing timeout on every scroll event
        if (showTimeout) {
            clearTimeout(showTimeout);
        }

        // 1. If at footer, force hide and stop
        if (isFooterVisible) {
            ticket.classList.remove('is-visible');
            lastScrollY = currentScrollY;
            return;
        }

        // 3. Scroll Direction Logic
        if (currentScrollY > lastScrollY) {
            // Scrolling DOWN -> Show
            ticket.classList.add('is-visible');
        } else if (currentScrollY < lastScrollY) {
            // Scrolling UP -> Hide
            ticket.classList.remove('is-visible');

            // Show again after 2 seconds
            showTimeout = setTimeout(() => {
                if (!isFooterVisible) {
                    ticket.classList.add('is-visible');
                }
            }, 2000);
        }

        lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    window.addEventListener('resize', handleScroll);

    // Initial check
    checkVisibility();
};
